import React from 'react';
import PropTypes from 'prop-types';
import strings from 'localization/strings';
import { convertToNumber } from 'helpers/StringHelper';
import { mustBeBetween } from 'form/validation';
import { TextField, showErrorOnBlur } from 'mui-rff';

import Form from 'form/Form';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const SubscriptionRecurringPurchaseDayOfMonthDialog = ({ booking, open, onOk, onCancel }) => {
    const initialValues = {
        subscriptionRecurringPurchaseDayOfMonth: booking.subscriptionRecurringPurchaseDayOfMonth
    };

    const handleFormSubmit = values => {
        onOk({
            subscriptionRecurringPurchaseDayOfMonth: convertToNumber(values.subscriptionRecurringPurchaseDayOfMonth)
        });
    };

    return (
        <Dialog fullWidth maxWidth="sm" open={open} onClose={onCancel}>
            <Form
                initialValues={initialValues}
                onSubmit={handleFormSubmit}
            >
                {({ handleSubmit, invalid }) => (
                    <form onSubmit={handleSubmit}>
                        <DialogTitle disableTypography>
                            <Typography variant="h5">
                                {strings.subscriptionRecurringPurchaseDayOfMonthDialogTitle}
                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            <Typography variant="body1" gutterBottom>
                                {strings.subscriptionRecurringPurchaseDayOfMonth}
                            </Typography>
                            <TextField
                                name="subscriptionRecurringPurchaseDayOfMonth"
                                variant="outlined"
                                showError={showErrorOnBlur}
                                fieldProps={{ validate: mustBeBetween(1, 28) }}
                                autoFocus
                                helperText={strings.subscriptionRecurringPurchaseDayOfMonthHelperText}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                                disabled={invalid}
                            >
                                {strings.ok}
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={onCancel}
                            >
                                {strings.cancel}
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Form>
        </Dialog>
    );
};

SubscriptionRecurringPurchaseDayOfMonthDialog.propTypes = {
    booking: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onOk: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default SubscriptionRecurringPurchaseDayOfMonthDialog;
